/** @format */

import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { GlobalContext } from "../../Contexts/GlobalContextProvider";
import { videos } from "../../Config/Consts";

const Index = () => {
  const { t: translator } = useTranslation();
  const { updateLocTab, updateLocName } = useContext(GlobalContext);

  useEffect(() => {
    updateLocName("video-instructions");
    updateLocTab(0);
  }, []);

  return (
    <div className="p-2 pt-3">
      <div className="card container-fluid p-0">
        <div className="card-header card-wrap">
          <span>
            {translator("VideoInstructions-View-Subtitle", "Video upute")}
          </span>
        </div>
        <div className="card-body">
          <div className="row">
            {videos
              .filter((video) => video.IsActive)
              .map((video) => (
                <div className="col-md-6 mb-4" key={video.Id}>
                  <div className="card h-100">
                    <div className="card-body">
                      <h6 className="card-title">{video.Name}</h6>
                      <video
                        controls
                        preload="metadata"
                        style={{ width: "100%", borderRadius: 4 }}
                      >
                        <source src={video.Url} type="video/mp4" />
                      </video>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
